module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("TO"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "large"
  }, [_vm._v("MR. AND MRS. THOMAS E. NEWBOLD")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nTHIS YARN IS SPUN WITH INFINITE AFFECTION")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('h2', {
    staticClass: "nobreak"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "allsmcap"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "allsmcap"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Visions")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h6.htm#Page_1"
    }
  }, [_vm._v("      1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Tragedy")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h7.htm#Page_8"
    }
  }, [_vm._v("      8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Testimony")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h8.htm#Page_23"
    }
  }, [_vm._v("      23")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("More Testimony")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h9.htm#Page_40"
    }
  }, [_vm._v("      40")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Dorothy Deane, “Society Editor”")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h10.htm#Page_66"
    }
  }, [_vm._v("      66")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Wall Between")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h11.htm#Page_81"
    }
  }, [_vm._v("      81")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("At Thornedale Lodge")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h12.htm#Page_98"
    }
  }, [_vm._v("      98")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Many Inventions")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h13.htm#Page_114"
    }
  }, [_vm._v("      114")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In the Attic")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h14.htm#Page_138"
    }
  }, [_vm._v("      138")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Black-Edged Card")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h15.htm#Page_154"
    }
  }, [_vm._v("      154")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mrs. Porter Grows Inquisitive")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h16.htm#Page_170"
    }
  }, [_vm._v("      170")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Detective Mitchell Asks Questions")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h17.htm#Page_186"
    }
  }, [_vm._v("      186")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Red Herring")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h18.htm#Page_205"
    }
  }, [_vm._v("      205")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Pro and Con")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h19.htm#Page_224"
    }
  }, [_vm._v("      224")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Edged Tools")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h20.htm#Page_243"
    }
  }, [_vm._v("      243")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Hare and Hounds")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h21.htm#Page_259"
    }
  }, [_vm._v("      259")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Vera Receives a Letter")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h22.htm#Page_279"
    }
  }, [_vm._v("      279")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Counterfeit Bank Note")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h23.htm#Page_293"
    }
  }, [_vm._v("      293")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The First Shot")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h24.htm#Page_313"
    }
  }, [_vm._v("      313")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', [_vm._v(" KA")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h25.htm#Page_322"
    }
  }, [_vm._v("      322")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Blind Man’s Buff")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h26.htm#Page_329"
    }
  }, [_vm._v("      329")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', [_vm._v(" “"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Moving Finger Writes")]), _vm._v("—”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h27.htm#Page_344"
    }
  }, [_vm._v("      344")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Out of the Maze")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3186253215635795556_74210h28.htm#Page_352"
    }
  }, [_vm._v("      352")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b211e1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3186253215635795556_74210-h-4.htm.vue
// module id = 69
// module chunks = 0